export enum MessageType {
	Incoming = 'incoming',
	Outgoing = 'outgoing',
}

export interface IMessage {
	type: MessageType;
	player: string;
	time: string;
	text: string;
	online: boolean;
}
